// Core system design configuration

export interface ThemeConfig {
  primaryColor: string;
  secondaryColor: string;
  textColor: {
    primary: string;
    secondary: string;
    light: string;
  };
  logo: {
    main: string;
    mainBase64?: string;
  };
  fonts: {
    primary: string;
    secondary: string;
  };
}

export const systemTheme: ThemeConfig = {
  primaryColor: '#34af22', // Bootstrap primary blue
  secondaryColor: '#ffffff',
  textColor: {
    primary: '#333333',
    secondary: '#6C757D',
    light: '#FFFFFF'
  },
  logo: {
    main: 'https://playbpo.vercel.app/splash.png',
    white: 'https://playbpo.vercel.app/playbpo.png'
  },
  fonts: {
    primary: 'Inter, sans-serif',
    secondary: 'Roboto, sans-serif'
  }
};

// Helper function to get theme configuration
export const getThemeConfig = () => systemTheme;
